<template>
  <div class="switch-item">
    <div class="switch-item__text"><slot /></div>
    <label
      class="switch-item__toggle"
      :class="[{ disabled: disabled }, { check: checked }]"
    >
      <input type="checkbox" class="switch-item__input" v-model="checked" />
    </label>
  </div>
</template>

<script>
export default {
  name: "SwitchItem",

  props: {
    value: {
      type: [Boolean, null],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/media";

.switch-item {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  align-items: flex-start;

  @include respond-up(lg) {
    flex-direction: row;
  }
  &__toggle {
    position: relative;
    width: 38px;
    height: 16px;
    margin-top: 2px;
    margin-right: 15px;
    border-radius: 19px;
    border: 1px solid #d3d3d3;
    background: #ebebeb;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    transition: border-color 0.2s linear, background 0.2s linear;

    @include respond-up(lg) {
      margin-right: 0;
    }
    &.disabled {
      pointer-events: none;
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: -2px;
      left: -1px;
      width: 18px;
      height: 18px;
      box-sizing: border-box;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.14);
      border-radius: 50%;
      border: 1px solid #e4e4e4;
      background: #fefefe;
      user-select: none;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      transition: left 0.2s linear, border-color 0.2s linear,
        background 0.2s linear;
    }
    &.check {
      background: #c8e2ed;
      border-color: #95d6f3;

      &:after {
        left: 19px;
        border-color: #009ee3;
        background: #009ee3;
      }
    }
  }
  &__text {
    flex: 1;
    font-size: 13px;
    line-height: 20px;
    color: #000000;
  }
}
</style>
